<template>
  <div class="configuration-card">
    <div
      v-if="$slots.default"
      class="configuration-card__image"
    >
      <slot />
    </div>
    <div class="configuration-card__content">
      <div class="configuration-card__content-details">
        <slot name="details" />
      </div>
      <div class="configuration-card__content-actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="configuration-card__menu">
      <slot name="menu" />
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.configuration-card {
  display: flex;
  align-items: center;
  background-color: map-get($background-color, dark);
  border-radius: map-get($border-radius, heavier);
  padding: bu(2);
  margin-bottom: bu(1);

  &__image {
    background-color: map-get($background-color, light);
    border-radius: map-get($border-radius, heavy);
    overflow: hidden;
    position: relative;
    width: bu(5.5);
    height: bu(5.5);
    min-width: bu(5.5);
  }

  &__content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-left: bu(2);
    flex-direction: row;
    align-items: center;
  }

  &__content-details {
    flex: auto;
    margin-bottom: 0;
  }
}
</style>
